/**
 * @generated SignedSource<<a8772cac2bb4226c6fe4f8580f10be12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type ProcessDefinitionFilterInput = {
  definitionId?: StringFilter | null | undefined;
  definitionKey?: StringFilter | null | undefined;
  definitionName?: StringFilter | null | undefined;
  definitionPriority?: IntFilter | null | undefined;
  definitionVersion?: StringFilter | null | undefined;
  id?: string | null | undefined;
  list?: StringFilter | null | undefined;
  siteUrl?: StringFilter | null | undefined;
  status?: EnumFilter | null | undefined;
};
export type StringFilter = {
  contains?: string | null | undefined;
  endsWith?: string | null | undefined;
  eq?: string | null | undefined;
  ignoreCase?: boolean | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  ne?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
  startsWith?: string | null | undefined;
};
export type EnumFilter = {
  eq?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  ne?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
};
export type IntFilter = {
  eq?: number | null | undefined;
  gt?: number | null | undefined;
  gte?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  lt?: number | null | undefined;
  lte?: number | null | undefined;
  ne?: number | null | undefined;
  notIn?: ReadonlyArray<number> | null | undefined;
};
export type processDefinitionsTemplateQuery$variables = {
  filter?: ProcessDefinitionFilterInput | null | undefined;
  pageNum?: number | null | undefined;
  pageSize?: number | null | undefined;
  search?: string | null | undefined;
  searchBy?: ReadonlyArray<string | null | undefined> | null | undefined;
  sortBy?: string | null | undefined;
  sortDir?: SortDirection | null | undefined;
};
export type processDefinitionsTemplateQuery$data = {
  readonly getProcessDefinitions: {
    readonly " $fragmentSpreads": FragmentRefs<"processDefinitionsTemplateQueryFragment">;
  };
};
export type processDefinitionsTemplateQuery = {
  response: processDefinitionsTemplateQuery$data;
  variables: processDefinitionsTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageNum"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDir"
},
v7 = [
  {
    "kind": "Variable",
    "name": "filterInput",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "pageNum",
    "variableName": "pageNum"
  },
  {
    "kind": "Variable",
    "name": "pageSize",
    "variableName": "pageSize"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "searchBy",
    "variableName": "searchBy"
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  },
  {
    "kind": "Variable",
    "name": "sortDir",
    "variableName": "sortDir"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "ProcessDefinitionPage",
        "kind": "LinkedField",
        "name": "getProcessDefinitions",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "processDefinitionsTemplateQueryFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "processDefinitionsTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "ProcessDefinitionPage",
        "kind": "LinkedField",
        "name": "getProcessDefinitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProcessDefinition",
            "kind": "LinkedField",
            "name": "content",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitionKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitionName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitionVersion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "modifiedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startWhen",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPrevious",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFirst",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLast",
                "storageKey": null
              },
              {
                "alias": "pageNum",
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": "pageSize",
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Sort",
                "kind": "LinkedField",
                "name": "sort",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSorted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnsorted",
                    "storageKey": null
                  },
                  {
                    "alias": "orders",
                    "args": null,
                    "concreteType": "Order",
                    "kind": "LinkedField",
                    "name": "toList",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "direction",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAscending",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDescending",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "property",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalElements",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fde623e1167d82b280fe6534737621eb",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsTemplateQuery",
    "operationKind": "query",
    "text": "query processDefinitionsTemplateQuery(\n  $pageNum: Int\n  $pageSize: Int\n  $sortBy: String\n  $sortDir: SortDirection\n  $search: String\n  $searchBy: [String]\n  $filter: ProcessDefinitionFilterInput\n) {\n  getProcessDefinitions(pageNum: $pageNum, pageSize: $pageSize, sortBy: $sortBy, sortDir: $sortDir, search: $search, searchBy: $searchBy, filterInput: $filter) {\n    ...processDefinitionsTemplateQueryFragment\n  }\n}\n\nfragment listPaginationQueryFragment on PageInfo {\n  hasContent\n  hasNext\n  hasPrevious\n  isFirst\n  isLast\n  pageNum: number\n  pageSize: size\n  sort {\n    ...listPaginationQuerySortFragment\n  }\n  totalElements\n  totalPages\n}\n\nfragment listPaginationQuerySortFragment on Sort {\n  isSorted\n  isUnsorted\n  orders: toList {\n    direction\n    isAscending\n    isDescending\n    property\n  }\n}\n\nfragment processDefinitionsTemplateQueryFragment on ProcessDefinitionPage {\n  content {\n    createdAt\n    id\n    definitionKey\n    definitionName\n    definitionVersion\n    modifiedAt\n    startWhen\n    status\n  }\n  pageInfo {\n    ...listPaginationQueryFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "070d53afcc4ebb1bfa318dfb86729a5f";

export default node;
